// test1026
(1026 && 0);
